import getMailTipsService from '../services/getMailTipsService';
import getMailTipsInformationFromXML from '../utils/getMailTipsInformationFromXML';
import { orchestrator } from 'satcheljs';
import getMailTips from '../selectors/getMailTips';
import addMailTipsToCache from '../mutators/addMailTipsToCache';
import updateMailtips from '../actions/updateMailtips';
import onMailTipRetrieved from '../actions/onMailTipRetrieved';
import { logUsage } from 'owa-analytics';

/**
 * Calls getMailTips and stores the response in MailTipsCache by calling addMailTipsToCache
 */
export default orchestrator(updateMailtips, async actionMessage => {
    const { composeId, fromEmailAddress, recipients } = actionMessage;

    // We make the service call for the below conditions:
    // 1. If there are no mailTips for the given sender email address in which case we know that there doesn't exist any mailTips for the recipient + sender combination
    // 2. If there are no mailTips present for the recipient email address.
    if (fromEmailAddress && recipients && recipients.length) {
        const mailTips = getMailTips();
        const uncachedRecipientEmailAddresses = recipients.filter(recipientEmailAddress => {
            return (
                recipientEmailAddress &&
                !mailTips.containsValueForKey(fromEmailAddress, recipientEmailAddress)
            );
        });
        if (uncachedRecipientEmailAddresses.length) {
            // Make service call
            const response = await getMailTipsService(
                fromEmailAddress,
                uncachedRecipientEmailAddresses
            );
            // Populate response
            if (response) {
                const mailTipsInformationArray = response.ResponseMessages.map(
                    singleResponseMessage => {
                        return getMailTipsInformationFromXML(singleResponseMessage.MessageText);
                    }
                ).filter(value => !!value);
                if (mailTipsInformationArray && mailTipsInformationArray.length > 0) {
                    addMailTipsToCache(mailTipsInformationArray, fromEmailAddress);
                    onMailTipRetrieved(composeId, fromEmailAddress);
                }
            }
        } else {
            onMailTipRetrieved(composeId, fromEmailAddress);
        }

        // Log datapoint
        recipients.map(recipient => {
            let isEntryCached = false;
            if (uncachedRecipientEmailAddresses.indexOf(recipient) == -1) {
                isEntryCached = true;
            }

            logUsage('UpdateMailtipsDatapoint', [isEntryCached]);
        });
    }
});
